import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import LetterTile from './LetterTile';
import { emptyPrompts } from '../lib/copy';

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const sizeForLength = (len) => {
  if (len <= 4) return 'lg';
  if (len <= 6) return 'md';
  if (len <= 9) return 'sm';
  return 'xs';
};

const WordScramble = ({ word, onWordScramble, currentDelay, revealedLetters, playerWords, currentTurn }) => {
  const [letters, setLetters] = useState(word.split(''));
  const [isMounted, setIsMounted] = useState(false);
  const [totalWordCount, setTotalWordCount] = useState(0);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    let totalLength = 0;
    for (const key in playerWords) {
      if (Object.prototype.hasOwnProperty.call(playerWords, key)) {
        totalLength += playerWords[key].length;
      }
    }
    setTotalWordCount(totalLength);
  }, [playerWords]);

  useEffect(() => {
    setLetters(word.split(''));
  }, [word]);

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const newLetters = reorder(letters, result.source.index, result.destination.index);
    setLetters(newLetters);
    onWordScramble(newLetters.join(''));
  };

  if (currentTurn < -1) return null;

  const tileSize = sizeForLength(letters.length);
  const hasWords = playerWords && Object.keys(playerWords).length > 0;

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      {letters.length > 0 && isMounted && currentDelay === 0 && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '78px',
          }}
        >
          <Droppable droppableId="droppable" direction="horizontal">
            {(provided) => (
              <div
                ref={provided.innerRef}
                style={{ display: 'flex', gap: '6px', padding: '2px' }}
                {...provided.droppableProps}
              >
                {letters.map((letter, index) => (
                  <Draggable key={index} draggableId={String(index)} index={index}>
                    {(prov, snapshot) => (
                      <div
                        ref={prov.innerRef}
                        {...prov.draggableProps}
                        {...prov.dragHandleProps}
                        style={{ ...prov.draggableProps.style, cursor: 'grab' }}
                      >
                        <LetterTile
                          letter={letter}
                          size={tileSize}
                          className={snapshot.isDragging ? 'sg-tile--selected' : ''}
                        />
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </div>
      )}

      {letters.length === 0 && currentDelay === 0 && revealedLetters && totalWordCount < 5 && (
        <div
          className="sg-faint"
          style={{ textAlign: 'center', fontWeight: 600, minHeight: '78px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 12px' }}
        >
          {hasWords ? (
            <span>{emptyPrompts.combine}</span>
          ) : revealedLetters.length >= 3 ? (
            <span>{emptyPrompts.pickLetters}</span>
          ) : (
            <span>&nbsp;</span>
          )}
        </div>
      )}
    </DragDropContext>
  );
};

export default WordScramble;
